import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewDayComponent } from "./med-icon-view-day.component";

@NgModule({
  declarations: [
    MedIconViewDayComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewDayComponent,
  ],
})
export class MedIconViewDayModule { }
